import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute, PublicOnlyRoute } from "@/hooks/useAuth";
import { ThemeProvider } from "@/hooks/useTheme";
import { AppShell } from "@/components/layout/AppShell";
import { RequireModule } from "@/components/layout/RequireModule";

import LoginPage from "@/pages/login/LoginPage";
import ForgotPasswordPage from "@/pages/login/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/login/ResetPasswordPage";
import InvitationSetupPage from "@/pages/login/InvitationSetupPage";

import DashboardPage from "@/pages/dashboard/DashboardPage";
import OrdersPage from "@/pages/orders/OrdersPage";
import InboundPage from "@/pages/inbound/InboundPage";
import InventoryPage from "@/pages/inventory/InventoryPage";
import ReturnsPage from "@/pages/returns/ReturnsPage";
import ClientsPage from "@/pages/clients/ClientsPage";
import StoresPage from "@/pages/stores/StoresPage";
import WarehousesPage from "@/pages/warehouses/WarehousesPage";
import UsersPage from "@/pages/users/UsersPage";
import VaAgenciesPage from "@/pages/va-agencies/VaAgenciesPage";
import InvoicingPage from "@/pages/invoicing/InvoicingPage";
import ActivityLogPage from "@/pages/activity-log/ActivityLogPage";
import SettingsPage from "@/pages/settings/SettingsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import LandingPage from "@/pages/landing/LandingPage";
import MarketingLayout from "@/pages/landing/MarketingLayout";
import FeaturesPage from "@/pages/landing/FeaturesPage";
import PricingPage from "@/pages/landing/PricingPage";
import ContactPage from "@/pages/landing/ContactPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          {/* Public / auth routes */}
          <Route
            path="/login"
            element={
              <PublicOnlyRoute>
                <LoginPage />
              </PublicOnlyRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicOnlyRoute>
                <ForgotPasswordPage />
              </PublicOnlyRoute>
            }
          />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/invite" element={<InvitationSetupPage />} />

          {/* Protected application shell */}
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/orders" element={<RequireModule module="orders"><OrdersPage /></RequireModule>} />
            <Route path="/inbound" element={<RequireModule module="inbound"><InboundPage /></RequireModule>} />
            <Route path="/inventory" element={<RequireModule module="inventory"><InventoryPage /></RequireModule>} />
            <Route path="/returns" element={<RequireModule module="returns"><ReturnsPage /></RequireModule>} />
            <Route path="/warehouses" element={<RequireModule module="warehouses"><WarehousesPage /></RequireModule>} />
            <Route path="/clients" element={<RequireModule module="clients"><ClientsPage /></RequireModule>} />
            <Route path="/stores" element={<RequireModule module="stores"><StoresPage /></RequireModule>} />
            <Route path="/users" element={<RequireModule module="users"><UsersPage /></RequireModule>} />
            <Route path="/va-agencies" element={<RequireModule module="va-agencies"><VaAgenciesPage /></RequireModule>} />
            <Route path="/invoicing" element={<RequireModule module="invoicing"><InvoicingPage /></RequireModule>} />
            <Route path="/activity-log" element={<RequireModule module="activity-log"><ActivityLogPage /></RequireModule>} />
            <Route path="/settings" element={<RequireModule module="settings"><SettingsPage /></RequireModule>} />
          </Route>

          <Route element={<MarketingLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
